import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';

import 'bootstrap/dist/js/bootstrap.js';

Sentry.init({
  dsn:
    process.env.REACT_APP_SENTRY_DSN ||
    'https://933dbe64c0abf6d8c63f64077b8e5066@o4511026198282240.ingest.us.sentry.io/4511026199330816',
  sendDefaultPii: false
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
